import { SaveToCloudStatus } from './schema/SxSExtendedViewState';
import EventEmitter from 'owa-event-emitter';
import getInitialSxSViewState from 'owa-sxsdata/lib/utils/getInitialSxSViewState';
import { createStore } from 'satcheljs';
var initialStore = {
    shouldShow: false,
    viewState: getInitialSxSViewState(),
    extendedViewState: {
        previewMode: 0,
        attachmentId: null,
        selectionSource: 0,
        isCloudy: false,
        saveToCloudStatus: SaveToCloudStatus.disabled,
    },
    editState: {
        mode: 0,
        editAllowed: false,
        itemId: null,
        isDraft: false,
    },
    customPreviewState: null,
    eventManager: new EventEmitter(),
    pendingPreviewOperation: null,
    pendingNavigation: null,
    readingPaneState: null,
    composeState: null,
    customization: null,
    isInvisible: false,
    shouldUseFakeRightHandSide: false,
    isUsingFakeRightHandSide: false,
    shouldHideReadingPaneOutsideSxS: false,
};
initialStore.viewState.previewPane = null;
export var getStore = createStore('sxsstore', initialStore);
export default getStore();
//# sourceMappingURL=Store.js.map